import { ScoreDetail } from '../game-engine/plongeur';
import { GlobalScore, PlongeurEnum } from '../plongeon';
import { GlobalScoreLayout } from '../../shared/global-score-layout/global-score-layout';
import { ScoreCard } from '../../shared/score-card/score-card';
import { ScoreDetailsComponent } from './score-details';

export const GlobalScoreComponent: React.FC<{ score: GlobalScore }> = ({ score }) => {
  const totalScore = score.reduce((total, plongeurScore) => total + plongeurScore.score, 0);

  return (
    <GlobalScoreLayout totalScore={totalScore}>
      {score.map((scoreData: {
        score: number;
        detail: ScoreDetail;
        plongeur: PlongeurEnum;
      }, index: number) => (
        <ScoreCard
          key={index}
          name={scoreData.plongeur}
          score={scoreData.score}
        >
          <ScoreDetailsComponent scoreDetails={scoreData.detail} />
        </ScoreCard>
      ))}
    </GlobalScoreLayout>
  );
}
